import React from "react";
import { IReducerAction } from "../../../store/reducer/types";
import { IEntity } from "../../../store/types";
import GambitTable from "../../BattleScreen/GambitTable";
import Sprite from "../../BattleScreen/Sprite";
import { styleClassName } from "../../styleHelper";
import AutoComplete from "./Autocomplete";
import { Button } from "../Common";
import { ActorEntryProps } from "../types";

export const actorActions = (
  dispatch: React.Dispatch<IReducerAction>,
  index: number
) => ({
  swapItems: (order: number, otherOrder: number) => {
    dispatch({ type: "gambit/swap", payload: { index, order, otherOrder } });
  },
  toggleItemActive: (id: string) => {
    dispatch({ type: "gambit/activate", payload: { index, id } });
  },
  changeItem: (id: string) => {
    dispatch({ type: "pick/pickGambit", payload: { index, id } });
  }
});

export function Actor(props: ActorEntryProps) {
  const { actor, actions, onFrameChange, addGambit } = props;
  // action defined here because GambitTable does not need it
  const className = styleClassName("nes-container with-title  actor-container");

  return (
    <div className={className}>
      <p className="title">Actor</p>
      <div>
        <AutoComplete
          onFound={(pick: string) => onFrameChange(actor.id, pick)}
        />
        {/* We make sure lastAction is null so no effect animation is played */}
        <Sprite {...{ name: actor.frame.name, lastAction: null }} />
        <GambitTable gambitData={actor.gambits} actions={actions} />
      </div>
      <Button onClick={addGambit} label="Add Gambit" />
    </div>
  );
}

interface ActorsProps {
  actors: IEntity[];
  onFrameChange: (actorId: string, frameName: string) => void;
  generateActorActions: (index: number) => ActorEntryProps["actions"];
  addGambit: (index: number) => void;
}

export function Actors(props: ActorsProps) {
  const { actors, onFrameChange, generateActorActions, addGambit } = props;
  return (
    <>
      {actors.map((actor, index) => (
        <Actor
          key={actor.id}
          actor={actor}
          onFrameChange={onFrameChange}
          actions={generateActorActions(index)}
          addGambit={() => addGambit(index)}
        />
      ))}
    </>
  );
}
